"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const FileUploadIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 24 24" }),
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 4H7C6.44772 4 6 4.44772 6 5V19C6 19.5523 6.44772 20 7 20H17C17.5523 20 18 19.5523 18 19V8.41421C18 8.26992 17.9688 8.12885 17.9102 8H14.5C13.6716 8 13 7.32843 13 6.5V4Z" }),
    react_1.default.createElement("path", { d: "M17 7H14.5C14.2239 7 14 6.77614 14 6.5V4.08982C14.108 4.13896 14.2074 4.20739 14.2929 4.29289L17 7Z" })));
exports.FileUploadIcon = FileUploadIcon;
exports.default = exports.FileUploadIcon;
